import { forwardRef } from "react";
import SystemIcon from "./SystemIcon";

function withClass(base, className) {
  return `${base}${className ? ` ${className}` : ""}`;
}

const SIZE_ALIASES = {
  sm: "small",
  md: "medium",
  lg: "large",
};

const SELECT_ICON_SIZE = {
  small: "xsmall",
  medium: "xsmall",
  large: "xsmall",
};

function normalizeSize(size) {
  return SIZE_ALIASES[size] || size;
}

export const TextInput = forwardRef(function TextInput({
  size = "medium",
  className = "",
  ...props
}, ref) {
  const normalizedSize = normalizeSize(size);
  return (
    <input
      ref={ref}
      className={withClass(`ds-input ds-input--${normalizedSize}`, className)}
      lang="ko-KR"
      autoCapitalize="off"
      autoCorrect="off"
      spellCheck={false}
      {...props}
    />
  );
});

export const TextArea = forwardRef(function TextArea({
  size = "medium",
  className = "",
  ...props
}, ref) {
  const normalizedSize = normalizeSize(size);
  return (
    <textarea
      ref={ref}
      className={withClass(`ds-input ds-input--${normalizedSize} ds-textarea`, className)}
      lang="ko-KR"
      autoCapitalize="off"
      autoCorrect="off"
      spellCheck={false}
      {...props}
    />
  );
});

export const NativeSelect = forwardRef(function NativeSelect({
  size = "medium",
  className = "",
  wrapperClassName = "",
  children,
  ...props
}, ref) {
  const normalizedSize = normalizeSize(size);
  return (
    <span
      className={`ds-select-wrap ds-select-wrap--${normalizedSize}${wrapperClassName ? ` ${wrapperClassName}` : ""}`}
    >
      <select
        ref={ref}
        className={withClass(`ds-input ds-select ds-select--${normalizedSize}`, className)}
        {...props}
      >
        {children}
      </select>
      <SystemIcon
        name="angle"
        size={SELECT_ICON_SIZE[normalizedSize] || "medium"}
        className="ds-select-icon"
      />
    </span>
  );
});

export function ReadonlyValue({ size = "medium", className = "", children, ...props }) {
  const normalizedSize = normalizeSize(size);
  return (
    <div className={withClass(`ds-readonly ds-input--${normalizedSize}`, className)} {...props}>
      {children}
    </div>
  );
}
